module.exports = __webpack_public_path__ + "static/media/INZ1256.7f5854fc.pdf";